/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Link } from "gatsby";
import arrow_long from "../images/arrow_long.svg";

export default (props: {
	className?: string;
	href: string;
	target?: string;
	children: string;
}) => {
	return (
		<Link
			to={props.href}
			target={props.target}
			style={{ textDecoration: `none` }}
		>
			<div
				className={props.className}
				css={{
					// cursor: "pointer",
					whiteSpace: "nowrap",
					display: "inline-block",
					position: "relative",
					padding: "24px 0",
					":hover img": {
						transform: "translateX(12px)",
						opacity: 1,
						transition:
							"all 800ms cubic-bezier(0.165, 0.84, 0.44, 1)",
					},
				}}
			>
				{/* <MovingLine
                color="#E85322"
                strokeWidth={2} // 1.5 veniva male, per cui ho messo 2
                radius={25}
                position="underline"
              >
                <span children={L("discoverMore")} />
              </MovingLine> */}
				<span
					children={props.children}
					css={css`
						font-size: 18px;
						font-weight: 700;
						text-transform: uppercase;
						color: #e85322;
						@media screen and (max-width: 599.9px) {
							fontsize: 16px;
						}
					`}
				/>
				<img
					src={arrow_long}
					css={css`
						margin-bottom: -1px;
						margin-left: 4px;
						transform: translateX(0px);
						opacity: 0;
						transition: all 300ms cubic-bezier(0.165, 0.84, 0.44, 1);
					`}
				/>
			</div>
		</Link>
	);
};
